"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8096],{

/***/ 94990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Trigger/index.js + 2 modules
var Trigger = __webpack_require__(12830);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMore/index.js
var IconMore = __webpack_require__(47962);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Dropdown/button.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var defaultProps = {
    position: 'br',
    trigger: 'hover',
    type: 'default',
    icon: react.createElement(IconMore/* default */.Z, null),
    unmountOnExit: true,
};
function button_Button(baseProps, ref) {
    var _a;
    var componentConfig = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).componentConfig;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig['Dropdown.Button']);
    var className = props.className, style = props.style, children = props.children, disabled = props.disabled, _b = props.position, position = _b === void 0 ? 'br' : _b, _c = props.type, type = _c === void 0 ? 'default' : _c, size = props.size, _d = props.icon, icon = _d === void 0 ? react.createElement(IconMore/* default */.Z, null) : _d, onClick = props.onClick, buttonProps = props.buttonProps, buttonsRender = props.buttonsRender, dropdownRestProps = __rest(props, ["className", "style", "children", "disabled", "position", "type", "size", "icon", "onClick", "buttonProps", "buttonsRender"]);
    var leftButton = (react.createElement(Button/* default */.Z, __assign({ disabled: disabled, type: type, size: size, onClick: onClick }, buttonProps), children));
    var rightButton = (react.createElement(Button/* default */.Z, { disabled: disabled, type: type, size: size, icon: icon }));
    if (buttonsRender) {
        _a = __read(buttonsRender([leftButton, rightButton]), 2), leftButton = _a[0], rightButton = _a[1];
    }
    var disableTrigger = disabled ||
        !rightButton ||
        (rightButton.props && rightButton.props.loading);
    return (react.createElement(Button/* default.Group */.Z.Group, __assign({ className: className, style: style, ref: ref }, (0,pick/* pickDataAttributes */.m)(props)),
        leftButton,
        react.createElement(es_Dropdown, __assign({ disabled: disabled, position: position }, dropdownRestProps, { triggerProps: __assign({ disabled: disableTrigger }, dropdownRestProps === null || dropdownRestProps === void 0 ? void 0 : dropdownRestProps.triggerProps) }), rightButton)));
}
var ButtonComponent = (0,react.forwardRef)(button_Button);
ButtonComponent.displayName = 'DropdownButton';
/* harmony default export */ var Dropdown_button = (ButtonComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Dropdown/index.js
var Dropdown_assign = (undefined && undefined.__assign) || function () {
    Dropdown_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Dropdown_assign.apply(this, arguments);
};
var Dropdown_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var Dropdown_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};










var Dropdown_defaultProps = {
    position: 'bl',
    trigger: 'hover',
    unmountOnExit: true,
};
var trigerPopupAlign = {
    left: 4,
    right: 4,
    top: 4,
    bottom: 4,
};
function Dropdown(baseProps, _) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, Dropdown_defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Button);
    var trigger = props.trigger, droplist = props.droplist, children = props.children, position = props.position, disabled = props.disabled, unmountOnExit = props.unmountOnExit, triggerProps = props.triggerProps, getPopupContainer = props.getPopupContainer, onVisibleChange = props.onVisibleChange, rest = Dropdown_rest(props, ["trigger", "droplist", "children", "position", "disabled", "unmountOnExit", "triggerProps", "getPopupContainer", "onVisibleChange"]);
    var prefixCls = getPrefixCls('dropdown');
    var triggerRef = (0,react.useRef)(null);
    var _c = Dropdown_read((0,useMergeValue/* default */.Z)(false, {
        defaultValue: props.defaultPopupVisible,
        value: props.popupVisible,
    }), 2), popupVisible = _c[0], setPopupVisible = _c[1];
    var getPopupContent = function () {
        return react.Children.only(droplist || react.createElement("span", null));
    };
    var changePopupVisible = function (visible) {
        setPopupVisible(visible);
        onVisibleChange && onVisibleChange(visible);
        triggerProps && triggerProps.onVisibleChange && triggerProps.onVisibleChange(visible);
    };
    var handleVisibleChange = function (visible) {
        if (visible !== popupVisible) {
            changePopupVisible(visible);
        }
    };
    var renderPopup = function () {
        var e_1, _a, _b;
        var content = getPopupContent();
        // props.isMenu: Compatible Menu.defaultProps.isMenu = true
        if (get_default()(content, 'type.__ARCO_MENU__') || get_default()(content, 'props.isMenu')) {
            var isEmpty = true;
            try {
                for (var _c = __values(react.Children.toArray(content.props.children)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var child = _d.value;
                    if (child !== null && child !== undefined) {
                        isEmpty = false;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return react.cloneElement(content, {
                prefixCls: (0,classNames/* default */.Z)(prefixCls + "-menu", (_b = {},
                    _b[prefixCls + "-menu-hidden"] = isEmpty,
                    _b)),
                inDropdown: true,
                selectable: false,
                onClickMenuItem: function () {
                    var _a;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var returnValueOfOnClickMenuItem = null;
                    // Trigger onClickMenuItem first
                    var content = getPopupContent();
                    if (content.props.onClickMenuItem) {
                        returnValueOfOnClickMenuItem = (_a = content.props).onClickMenuItem.apply(_a, __spreadArray([], Dropdown_read(args), false));
                    }
                    // Set focus to avoid onblur
                    var child = triggerRef.current && triggerRef.current.getRootElement();
                    child && child.focus && child.focus();
                    // Trigger onVisibleChange. Outer component can determine whether to change the state based on the current visibility value.
                    if (returnValueOfOnClickMenuItem instanceof Promise) {
                        returnValueOfOnClickMenuItem.finally(function () { return changePopupVisible(false); });
                    }
                    else if (returnValueOfOnClickMenuItem !== false) {
                        changePopupVisible(false);
                    }
                },
            });
        }
        return content;
    };
    return (react.createElement(Trigger/* default */.Z, Dropdown_assign({ ref: function (ref) { return (triggerRef.current = ref); }, classNames: "slideDynamicOrigin", childrenPrefix: prefixCls, trigger: trigger, popup: renderPopup, mouseEnterDelay: 400, mouseLeaveDelay: 400, disabled: disabled, unmountOnExit: unmountOnExit, position: position, popupVisible: popupVisible, popupAlign: trigerPopupAlign, getPopupContainer: getPopupContainer, alignPoint: trigger === 'contextMenu' }, (0,pick/* default */.Z)(rest, Trigger/* EventsByTriggerNeed */.C), (0,pick/* pickDataAttributes */.m)(rest), (0,omit/* default */.Z)(triggerProps, ['onVisibleChange']), { onVisibleChange: handleVisibleChange }), react.isValidElement(children)
        ? react.cloneElement(children, Dropdown_assign(Dropdown_assign({}, (typeof disabled === 'boolean' ? { disabled: disabled } : {})), { className: (0,classNames/* default */.Z)((_a = {},
                _a[prefixCls + "-popup-visible"] = popupVisible,
                _a[[prefixCls] + "-rtl"] = rtl,
                _a), children.props.className) }))
        : children));
}
var ForwardRefDropdown = react.forwardRef(Dropdown);
var DropdownComponent = ForwardRefDropdown;
DropdownComponent.displayName = 'Dropdown';
DropdownComponent.Button = Dropdown_button;
/* harmony default export */ var es_Dropdown = (DropdownComponent);


/***/ }),

/***/ 1389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ SiderContext; },
  "Z": function() { return /* binding */ sider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDragDotVertical/index.js
var IconDragDotVertical = __webpack_require__(81181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/context.js
var context = __webpack_require__(4245);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDragDot/index.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconDragDotComponent(iconProps, ref) {
  var _useContext = (0,react.useContext)(context/* IconContext */.P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-drag-dot")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M40 17v2h-2v-2h2ZM25 17v2h-2v-2h2ZM10 17v2H8v-2h2ZM40 29v2h-2v-2h2ZM25 29v2h-2v-2h2ZM10 29v2H8v-2h2Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M40 17v2h-2v-2h2ZM25 17v2h-2v-2h2ZM10 17v2H8v-2h2ZM40 29v2h-2v-2h2ZM25 29v2h-2v-2h2ZM10 29v2H8v-2h2Z"
  }));
}

var IconDragDot = /*#__PURE__*/react.forwardRef(IconDragDotComponent);
IconDragDot.defaultProps = {
  isIcon: true
};
IconDragDot.displayName = 'IconDragDot';
/* harmony default export */ var react_icon_IconDragDot = (IconDragDot);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCaretRight/index.js
var IconCaretRight = __webpack_require__(67945);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCaretLeft/index.js
var IconCaretLeft = __webpack_require__(74280);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCaretDown/index.js
var IconCaretDown = __webpack_require__(99042);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCaretUp/index.js
var IconCaretUp = __webpack_require__(69195);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/ResizeBox/resize-trigger.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};












function ResizeTrigger(props) {
    var _a, _b;
    var className = props.className, direction = props.direction, icon = props.icon, onMouseDown = props.onMouseDown, onResize = props.onResize, children = props.children, _c = props.collapsible, collapsible = _c === void 0 ? {} : _c, _d = props.resizable, resizable = _d === void 0 ? true : _d, renderChildren = props.renderChildren, rest = __rest(props, ["className", "direction", "icon", "onMouseDown", "onResize", "children", "collapsible", "resizable", "renderChildren"]);
    var _e = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _e.getPrefixCls, rtl = _e.rtl;
    var prefixCls = getPrefixCls('resizebox-trigger');
    var isHorizontal = direction === 'horizontal';
    var rtlReverse = rtl && !isHorizontal;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + (isHorizontal ? 'horizontal' : 'vertical'), (_a = {}, _a[prefixCls + "-not-resizable"] = !resizable, _a), (_b = {}, _b[prefixCls + "-rtl"] = rtl, _b), className);
    var verticalTriggerIcon = rtlReverse
        ? [react.createElement(IconCaretRight/* default */.Z, { key: "prev" }), react.createElement(IconCaretLeft/* default */.Z, { key: "next" })]
        : [react.createElement(IconCaretLeft/* default */.Z, { key: "prev" }), react.createElement(IconCaretRight/* default */.Z, { key: "next" })];
    var prevCollapsedConfig = (0,is/* isObject */.Kn)(collapsible.prev)
        ? __assign(__assign({}, collapsible.prev), { icon: collapsible.prev.icon || (isHorizontal ? react.createElement(IconCaretUp/* default */.Z, null) : verticalTriggerIcon[0]) }) : {};
    var nextCollapsedConfig = (0,is/* isObject */.Kn)(collapsible.next)
        ? __assign(__assign({}, collapsible.next), { icon: collapsible.next.icon || (isHorizontal ? react.createElement(IconCaretDown/* default */.Z, null) : verticalTriggerIcon[1]) }) : {};
    var renderPrevCollapsedTrigger = function () {
        // 1. 传入了prev
        // 当前不在收缩状态，或者在反方向收缩状态时展示
        if ((prevCollapsedConfig.icon && !prevCollapsedConfig.collapsed) ||
            nextCollapsedConfig.collapsed) {
            return (react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-icon", (0,_util_classNames/* default */.Z)(prefixCls + "-prev")), onClick: prevCollapsedConfig.onClick }, prevCollapsedConfig.icon));
        }
        return react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-icon-empty") });
    };
    var renderNextCollapsedTrigger = function () {
        if ((nextCollapsedConfig.icon && !nextCollapsedConfig.collapsed) ||
            prevCollapsedConfig.collapsed) {
            return (react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-icon", (0,_util_classNames/* default */.Z)(prefixCls + "-next")), onClick: nextCollapsedConfig.onClick }, nextCollapsedConfig.icon));
        }
        return react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-icon-empty") });
    };
    var renderResizeTrigger = function () {
        if (resizable) {
            return (react.createElement("span", { className: prefixCls + "-icon" }, icon || (isHorizontal ? react.createElement(react_icon_IconDragDot, null) : react.createElement(IconDragDotVertical/* default */.Z, null))));
        }
        return react.createElement("span", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-icon-empty") });
    };
    var prev = renderPrevCollapsedTrigger();
    var trigger = renderResizeTrigger();
    var next = renderNextCollapsedTrigger();
    var renderIcon = function () {
        return (react.createElement("div", { className: prefixCls + "-icon-wrapper" },
            prev,
            trigger,
            next));
    };
    if (!resizable) {
        return (react.createElement("div", { className: classNames }, (0,is/* isFunction */.mf)(renderChildren)
            ? renderChildren(prev, trigger, next)
            : children || renderIcon()));
    }
    return (react.createElement(resizeObserver/* default */.Z, { onResize: onResize },
        react.createElement("div", __assign({}, (0,omit/* default */.Z)(rest, ['style']), { className: classNames, onMouseDown: onMouseDown }), (0,is/* isFunction */.mf)(renderChildren)
            ? renderChildren(prev, trigger, next)
            : children || renderIcon())));
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(81109);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/ResizeBox/split.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};






var DIRECTION_HORIZONTAL = 'horizontal';
var DIRECTION_VERTICAL = 'vertical';
function Split(props, ref) {
    var _a;
    var style = props.style, className = props.className, _b = props.component, component = _b === void 0 ? 'div' : _b, _c = props.direction, direction = _c === void 0 ? 'horizontal' : _c, icon = props.icon, _d = props.size, size = _d === void 0 ? 0.5 : _d, min = props.min, max = props.max, panes = props.panes, disabled = props.disabled, trigger = props.trigger;
    var _e = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _e.getPrefixCls, rtl = _e.rtl;
    var prefixCls = getPrefixCls('resizebox-split');
    var isHorizontal = direction.includes(DIRECTION_HORIZONTAL);
    var isReverse = direction.includes('reverse');
    var rtlReverse = isHorizontal && rtl;
    var isTriggerHorizontal = !isHorizontal;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + (isHorizontal ? DIRECTION_HORIZONTAL : DIRECTION_VERTICAL), (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), className);
    var _f = __read(panes, 2), firstPane = _f[0], secondPane = _f[1];
    var isPxSize = typeof size === 'string';
    var _g = __read((0,react.useState)(parseFloat(size)), 2), offset = _g[0], setOffset = _g[1];
    var _h = __read((0,react.useState)(0), 2), triggerSize = _h[0], setTriggerSize = _h[1];
    var recordRef = (0,react.useRef)({
        startX: 0,
        startY: 0,
        startWidth: 0,
        startHeight: 0,
        startOffset: 0,
        moving: false,
    });
    var wrapperRef = (0,react.useRef)();
    var paneContainers = (0,react.useRef)([]);
    (0,react.useImperativeHandle)(ref, function () { return wrapperRef.current; }, []);
    function px2percent(numerator, denominator) {
        return parseFloat(numerator) / parseFloat(denominator);
    }
    // startSize:  size of the total ResizeBox
    // startOffset: size of the first Panel
    // startPosition: position at the end of last moving
    // currentPosition: position at the end of current moving
    function getOffset(startSize, startOffset, startPosition, currentPosition) {
        //  0 < minOffsetRatio, maxOffsetRatio <1
        var minOffsetRatio = typeof min === 'string' ? px2percent(parseFloat(min), startSize) : min || 0;
        var maxOffsetRatio = typeof max === 'string' ? px2percent(parseFloat(max), startSize) : max || 1;
        var ratio = isReverse ? -1 : 1;
        var rtlRatio = rtlReverse ? -1 : 1;
        ratio *= rtlRatio;
        var moveOffset = isPxSize
            ? startOffset + (currentPosition - startPosition) * ratio
            : px2percent(startSize * startOffset + (currentPosition - startPosition) * ratio, startSize);
        var minOffset = isPxSize ? minOffsetRatio * startSize : minOffsetRatio;
        var maxOffset = isPxSize ? maxOffsetRatio * startSize : maxOffsetRatio;
        moveOffset = Math.max(moveOffset, minOffset);
        moveOffset = Math.min(moveOffset, maxOffset);
        return moveOffset;
    }
    // 移动开始，记录初始值，绑定移动事件
    function onTriggerMouseDown(e) {
        var _a, _b;
        props.onMovingStart && props.onMovingStart();
        recordRef.current.moving = true;
        recordRef.current.startX = e.pageX;
        recordRef.current.startY = e.pageY;
        recordRef.current.startWidth = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        recordRef.current.startHeight = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight;
        recordRef.current.startOffset = offset;
        (0,dom.on)(window, 'mousemove', moving);
        (0,dom.on)(window, 'touchmove', moving);
        (0,dom.on)(window, 'mouseup', moveEnd);
        (0,dom.on)(window, 'touchend', moveEnd);
        (0,dom.on)(window, 'contextmenu', moveEnd);
        document.body.style.cursor = isTriggerHorizontal ? 'row-resize' : 'col-resize';
    }
    // 移动中，更新 firstPane 的占位大小
    function moving(e) {
        if (recordRef.current.moving) {
            /* eslint-disable */
            var newOffset = isHorizontal
                ? getOffset(recordRef.current.startWidth, recordRef.current.startOffset, recordRef.current.startX, e.pageX)
                : getOffset(recordRef.current.startHeight, recordRef.current.startOffset, recordRef.current.startY, e.pageY);
            setOffset(newOffset);
            props.onMoving && props.onMoving(e, isPxSize ? newOffset + "px" : newOffset);
        }
    }
    // 移动结束，解除事件绑定
    function moveEnd() {
        recordRef.current.moving = false;
        (0,dom/* off */.S1)(window, 'mousemove', moving);
        (0,dom/* off */.S1)(window, 'touchmove', moving);
        (0,dom/* off */.S1)(window, 'mouseup', moveEnd);
        (0,dom/* off */.S1)(window, 'touchend', moveEnd);
        (0,dom/* off */.S1)(window, 'contextmenu', moveEnd);
        document.body.style.cursor = 'default';
        props.onMovingEnd && props.onMovingEnd();
    }
    // 更新 trigger 大小
    function onTriggerResize(e) {
        var contentRect = e[0].contentRect;
        var newTriggerSize = contentRect[isTriggerHorizontal ? 'height' : 'width'];
        setTriggerSize(newTriggerSize);
    }
    // 根据 offset 和 triggerSize 计算 firstPane 的样式
    function getFirstPaneSize() {
        var unit = isPxSize ? 'px' : '%';
        if (!offset)
            return "0" + unit;
        var baseVal = isPxSize ? offset : offset * 100;
        return "calc(" + baseVal + unit + " - " + triggerSize / 2 + "px)";
    }
    (0,react.useEffect)(function () {
        props.onPaneResize && props.onPaneResize(paneContainers.current);
    }, [offset, triggerSize]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        var newOffset = parseFloat(size);
        if (offset !== newOffset) {
            setOffset(newOffset);
        }
    }, [size]);
    var Tag = component;
    var firstPaneNode = (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-pane", 'first-pane'), style: { flexBasis: getFirstPaneSize() }, ref: function (el) {
            paneContainers.current[0] = el;
        } }, firstPane));
    var secondPaneNode = (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-pane", 'second-pane'), ref: function (el) {
            paneContainers.current[1] = el;
        } }, secondPane));
    var paneNodeArr = isReverse ? [secondPaneNode, firstPaneNode] : [firstPaneNode, secondPaneNode];
    return (react.createElement(Tag, { style: style, className: classNames, ref: wrapperRef },
        paneNodeArr[0],
        !disabled && (react.createElement(ResizeTrigger, { className: prefixCls + "-trigger", direction: isTriggerHorizontal ? DIRECTION_HORIZONTAL : DIRECTION_VERTICAL, icon: icon, onMouseDown: onTriggerMouseDown, onResize: onTriggerResize }, trigger)),
        paneNodeArr[1]));
}
var SplitComponent = (0,react.forwardRef)(Split);
SplitComponent.displayName = 'ResizeBoxSplit';
/* harmony default export */ var split = (SplitComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/ResizeBox/split-group.js
var split_group_assign = (undefined && undefined.__assign) || function () {
    split_group_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return split_group_assign.apply(this, arguments);
};
var split_group_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var split_group_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};







var split_group_DIRECTION_HORIZONTAL = 'horizontal';
var split_group_DIRECTION_VERTICAL = 'vertical';
function SplitGroup(props, ref) {
    var _a, _b;
    var panes = props.panes, style = props.style, className = props.className, _c = props.component, component = _c === void 0 ? 'div' : _c, _d = props.direction, direction = _d === void 0 ? 'horizontal' : _d, icon = props.icon, rest = split_group_rest(props, ["panes", "style", "className", "component", "direction", "icon"]);
    var _e = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _e.getPrefixCls, rtl = _e.rtl;
    var defaultOffset = 1 / panes.length;
    var wrapperRef = (0,react.useRef)();
    var recordRef = (0,react.useRef)(new Array(panes.length).fill({
        moving: false,
        startOffset: 0,
        startPosition: 0,
    }));
    var paneContainers = (0,react.useRef)([]);
    var movingIndex = (0,react.useRef)(0);
    var prevOffsets = (0,react.useRef)([]);
    var _f = split_group_read((0,react.useState)(new Array(panes.length).fill(defaultOffset)), 2), offsets = _f[0], setOffsets = _f[1];
    var _g = split_group_read((0,react.useState)(false), 2), isMoving = _g[0], setIsMoving = _g[1];
    var _h = split_group_read((0,react.useState)(new Array(panes.length).fill(0)), 2), triggerSize = _h[0], setTriggerSize = _h[1];
    var _j = split_group_read((0,react.useState)(new Array(Math.max(panes.length - 1, 0)).fill({ prev: false, next: false })), 2), collapsedStatus = _j[0], setCollapsedStatus = _j[1];
    var prefixCls = getPrefixCls('resizebox-split-group');
    var isHorizontal = direction === split_group_DIRECTION_HORIZONTAL;
    var rtlReverse = isHorizontal && rtl;
    var isTriggerHorizontal = !isHorizontal;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + (isHorizontal ? split_group_DIRECTION_HORIZONTAL : split_group_DIRECTION_VERTICAL), (_a = {}, _a[prefixCls + "-moving"] = isMoving, _a), (_b = {}, _b[prefixCls + "-rtl"] = rtl, _b), className);
    var Tag = component;
    // 获取初始的 offset, 将传入的size 都转为像素值。
    var getInitialOffsets = function () {
        var newOffsets = [];
        panes.forEach(function (pane) {
            var size = pane.size;
            if (!(0,is/* isUndefined */.o8)(size)) {
                newOffsets.push(formatSize(size));
            }
            else {
                newOffsets.push(undefined);
            }
        });
        // 剩余的空间均分给没有设置 size 的面板
        var noSizeArr = newOffsets.filter(function (size) { return !size; });
        var remainPercent = 1 -
            newOffsets.reduce(function (a, b) {
                var formatA = a || 0;
                var formatB = b || 0;
                return formatA + formatB;
            }, 0);
        var averagePercent = remainPercent / noSizeArr.length;
        newOffsets = newOffsets.map(function (size) {
            if (!(0,is/* isUndefined */.o8)(size)) {
                return size;
            }
            return averagePercent;
        });
        return newOffsets;
    };
    // 计算每一个面板的占位像素，需要减去前面跟当前伸缩杆的宽度
    var getPaneSize = function (index) {
        var prevTriggerSize = triggerSize[index - 1] || 0;
        var currentTriggerSize = triggerSize[index];
        var baseVal = offsets[index] * 100;
        var unit = '%';
        return "calc(" + baseVal + unit + " - " + (prevTriggerSize + currentTriggerSize) / 2 + "px)";
    };
    // 入参 百分比/像素值 => 全部转化为百分比(响应式)
    function formatSize(size) {
        var totalPX = isHorizontal ? wrapperRef.current.offsetWidth : wrapperRef.current.offsetHeight;
        if (!size || ((0,is/* isNumber */.hj)(size) && size < 0)) {
            return 0;
        }
        var percent = (0,is/* isString */.HD)(size) ? parseFloat(size) / totalPX : size;
        return Math.min(percent, 1);
    }
    // 计算阈值，因为伸缩杆会影响到当前面板 跟 下一个面板。所以同时计算两个阈值。
    var getMinAndMax = function (index) {
        var next = Math.min(index + 1, panes.length - 1);
        var totalOffset = offsets[index] + offsets[next];
        var currentMin = formatSize(panes[index].min) || 0;
        var currentMax = formatSize(panes[index].max) || totalOffset;
        var nextMin = formatSize(panes[next].min) || 0;
        var nextMax = formatSize(panes[next].max) || totalOffset;
        //  min 的优先级高于 max
        currentMax = Math.min(totalOffset - nextMin, currentMax);
        nextMax = Math.min(totalOffset - currentMin, nextMax);
        return {
            currentMin: currentMin,
            currentMax: currentMax,
            nextMin: nextMin,
            nextMax: nextMax,
        };
    };
    // 拖拽时，获取新的占位距离。影响当前面板跟下一个面板的占位值。
    var getNewOffsets = function (startOffset, startPosition, currentPosition) {
        var current = movingIndex.current;
        var next = current + 1;
        var newOffsets = __spreadArray([], split_group_read(offsets), false);
        var ratio = rtlReverse ? -1 : 1;
        var currentPercent = offsets[current];
        var nextPercent = offsets[next];
        var totalPercent = currentPercent + nextPercent;
        var _a = getMinAndMax(current), minOffset = _a.currentMin, maxOffset = _a.currentMax;
        var moveOffset = startOffset + formatSize((currentPosition - startPosition) * ratio + "px");
        moveOffset = Math.max(minOffset, moveOffset);
        moveOffset = Math.min(maxOffset, moveOffset);
        newOffsets[current] = moveOffset;
        // 保证 totalOffset = nextOffset + currentOffset  不变。
        newOffsets[next] = totalPercent - moveOffset;
        return newOffsets;
    };
    function onTriggerResize(e, index) {
        var contentRect = e[0].contentRect;
        var currentSize = contentRect[isTriggerHorizontal ? 'height' : 'width'];
        var newTriggerSize = __spreadArray([], split_group_read(triggerSize), false);
        newTriggerSize[index] = currentSize;
        setTriggerSize(newTriggerSize);
    }
    // 判断快速收缩按钮是否展示
    var getCollapsedConfig = function (index) {
        var collapsible = panes[index].collapsible;
        if (!(0,is/* isObject */.Kn)(collapsible)) {
            collapsible = !collapsible ? {} : { prev: true, next: true };
        }
        var prev = collapsible.prev, next = collapsible.next;
        if (!prev && !next) {
            return {};
        }
        if (!collapsedStatus[index]) {
            return {};
        }
        // 传入了prev的配置，或者 没有传入 prev 的配置，但是已经处于向下收缩完毕状态
        var hasPrev = !!prev || (!prev && collapsedStatus[index].next);
        // 传入了next的配置，或者 没有传入 next 的配置，但是已经处于向上收缩完毕状态
        var hasNext = !!next || (!next && collapsedStatus[index].prev);
        return { hasPrev: hasPrev, hasNext: hasNext };
    };
    // 移动开始，记录初始值，绑定移动事件
    function onTriggerMouseDown(e, index) {
        props.onMovingStart && props.onMovingStart(index);
        movingIndex.current = index;
        var currentRecord = recordRef.current[index];
        currentRecord.moving = true;
        currentRecord.startOffset = offsets[index];
        currentRecord.startPosition = isHorizontal ? e.pageX : e.pageY;
        setIsMoving(true);
        (0,dom.on)(window, 'mousemove', moving);
        (0,dom.on)(window, 'touchmove', moving);
        (0,dom.on)(window, 'mouseup', moveEnd);
        (0,dom.on)(window, 'touchend', moveEnd);
        (0,dom.on)(window, 'contextmenu', moveEnd);
        document.body.style.cursor = isTriggerHorizontal ? 'row-resize' : 'col-resize';
    }
    // 移动中，更新 当前面板跟下一个面板 占位大小
    function moving(e) {
        var index = movingIndex.current;
        var currentRecord = recordRef.current[index];
        var totalPX = isHorizontal ? wrapperRef.current.offsetWidth : wrapperRef.current.offsetHeight;
        if (currentRecord.moving) {
            var newOffsets = getNewOffsets(currentRecord.startOffset, currentRecord.startPosition, isHorizontal ? e.pageX : e.pageY);
            setOffsets(newOffsets);
            prevOffsets.current = newOffsets;
            props.onMoving &&
                props.onMoving(e, newOffsets.map(function (value) { return value * totalPX + "px"; }), index);
        }
    }
    // 移动结束，解除事件绑定
    function moveEnd() {
        var index = movingIndex.current;
        recordRef.current[index].moving = false;
        setIsMoving(false);
        (0,dom/* off */.S1)(window, 'mousemove', moving);
        (0,dom/* off */.S1)(window, 'touchmove', moving);
        (0,dom/* off */.S1)(window, 'mouseup', moveEnd);
        (0,dom/* off */.S1)(window, 'touchend', moveEnd);
        (0,dom/* off */.S1)(window, 'contextmenu', moveEnd);
        document.body.style.cursor = 'default';
        props.onMovingEnd && props.onMovingEnd(index);
    }
    // 点击快速收缩按钮的回调。
    function handleCollapsed(e, index, status, callback) {
        var next = index + 1;
        var newOffset = __spreadArray([], split_group_read(offsets), false);
        var currentOffset = offsets[index];
        var nextOffset = offsets[next];
        var totalOffset = currentOffset + nextOffset;
        var totalPX = isHorizontal ? wrapperRef.current.offsetWidth : wrapperRef.current.offsetHeight;
        var _a = getMinAndMax(index), currentMin = _a.currentMin, nextMin = _a.nextMin;
        // 取消收缩时，应该重置为上一个状态。所以从preOffsets里拿值
        var newCurrentOffset = prevOffsets.current[index];
        var newNextOffset = prevOffsets.current[next];
        // 当前面板的收缩状态。
        var collapsed = collapsedStatus[index][status];
        // 点击向上收缩按钮。收缩态是：currentPane = currentMin;
        if (status === 'prev') {
            // 如果下一个面板不是在收缩状态 或者 下一个面板被手动拖拽到收缩状态
            if (nextOffset !== nextMin || newNextOffset === nextMin) {
                // 当前面板收缩。
                newCurrentOffset = currentMin;
                newNextOffset = totalOffset - currentMin;
                collapsed = true;
            }
            // 点击向下收缩按钮
        }
        else if (currentOffset !== currentMin || newCurrentOffset === currentMin) {
            newCurrentOffset = totalOffset - nextMin;
            newNextOffset = nextMin;
            collapsed = true;
        }
        newOffset[index] = newCurrentOffset;
        newOffset[next] = newNextOffset;
        props.onMoving &&
            props.onMoving(e, newOffset.map(function (value) { return value * totalPX + "px"; }), index);
        props.onMovingEnd && props.onMovingEnd(index);
        setOffsets(newOffset);
        if ((0,is/* isFunction */.mf)(callback)) {
            callback(e, index, status, collapsed);
        }
    }
    (0,react.useEffect)(function () {
        var offsets = getInitialOffsets();
        setOffsets(offsets);
        prevOffsets.current = offsets;
    }, [JSON.stringify(panes.map(function (item) { return item.size; }))]);
    (0,react.useImperativeHandle)(ref, function () { return wrapperRef.current; }, []);
    (0,react.useEffect)(function () {
        var newCollapsedStatus = [];
        offsets.forEach(function (offset, index) {
            var currentCollapsedStatus = { prev: false, next: false };
            var next = index + 1;
            var _a = getMinAndMax(index), currentMin = _a.currentMin, nextMin = _a.nextMin;
            // 当 offsets 变化时，更新各个面板的 collapsed 状态
            if (offset === currentMin) {
                currentCollapsedStatus.prev = true;
            }
            else if (offsets[next] === nextMin) {
                currentCollapsedStatus.next = true;
            }
            newCollapsedStatus.push(currentCollapsedStatus);
        });
        setCollapsedStatus(newCollapsedStatus);
    }, [offsets]);
    return (react.createElement(Tag, split_group_assign({}, (0,omit/* default */.Z)(rest, ['onMovingStart', 'onPaneResize', 'onMoving', 'onMovingEnd']), { style: style, className: classNames, ref: wrapperRef }), panes.map(function (pane, index) {
        var content = pane.content, disabled = pane.disabled, trigger = pane.trigger, _a = pane.resizable, resizable = _a === void 0 ? true : _a, _b = pane.collapsible, collapsible = _b === void 0 ? {} : _b;
        var _c = getCollapsedConfig(index), hasPrev = _c.hasPrev, hasNext = _c.hasNext;
        var prevConfig = (0,is/* isObject */.Kn)(collapsible) && (0,is/* isObject */.Kn)(collapsible.prev) ? collapsible.prev : {};
        var nextConfig = (0,is/* isObject */.Kn)(collapsible) && (0,is/* isObject */.Kn)(collapsible.next) ? collapsible.next : {};
        return (react.createElement(react.Fragment, { key: index },
            react.createElement("div", { className: prefixCls + "-pane", style: { flexBasis: getPaneSize(index) }, ref: function (el) { return (paneContainers.current[index] = el); } }, content),
            !disabled && index !== panes.length - 1 && (react.createElement(ResizeTrigger, { className: prefixCls + "-trigger", direction: isTriggerHorizontal ? split_group_DIRECTION_HORIZONTAL : split_group_DIRECTION_VERTICAL, icon: icon, onResize: function (e) { return onTriggerResize(e, index); }, onMouseDown: function (e) { return onTriggerMouseDown(e, index); }, collapsible: {
                    prev: hasPrev
                        ? {
                            onClick: function (e) { return handleCollapsed(e, index, 'prev', prevConfig.onClick); },
                            icon: prevConfig.icon,
                            collapsed: collapsedStatus[index].prev,
                        }
                        : undefined,
                    next: hasNext
                        ? {
                            onClick: function (e) { return handleCollapsed(e, index, 'next', nextConfig.onClick); },
                            icon: nextConfig.icon,
                            collapsed: collapsedStatus[index].next,
                        }
                        : undefined,
                }, resizable: resizable, renderChildren: trigger }))));
    })));
}
var SplitGroupComponent = (0,react.forwardRef)(SplitGroup);
SplitGroupComponent.displayName = 'ResizeBoxSplitGroup';
/* harmony default export */ var split_group = (SplitGroupComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/ResizeBox/index.js
var ResizeBox_assign = (undefined && undefined.__assign) || function () {
    ResizeBox_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return ResizeBox_assign.apply(this, arguments);
};
var ResizeBox_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var ResizeBox_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};











var DIRECTION_LEFT = 'left';
var DIRECTION_RIGHT = 'right';
var DIRECTION_TOP = 'top';
var DIRECTION_BOTTOM = 'bottom';
var allDirections = [
    DIRECTION_LEFT,
    DIRECTION_RIGHT,
    DIRECTION_TOP,
    DIRECTION_BOTTOM,
];
var defaultProps = {
    component: 'div',
    directions: ['right'],
    resizeIcons: {},
    resizeTriggers: {},
};
var getOppositeDirection = function (direction) {
    switch (direction) {
        case 'left':
            return 'right';
        case 'right':
            return 'left';
        default:
            return direction;
    }
};
function ResizeBox(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.ResizeBox);
    var style = props.style, className = props.className, component = props.component, directions = props.directions, resizeIcons = props.resizeIcons, children = props.children, resizeTriggers = props.resizeTriggers, propWidth = props.width, propHeight = props.height, rest = ResizeBox_rest(props, ["style", "className", "component", "directions", "resizeIcons", "children", "resizeTriggers", "width", "height"]);
    var realDirections = rtl ? directions.map(function (dir) { return getOppositeDirection(dir); }) : directions;
    var prefixCls = getPrefixCls('resizebox');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), className);
    var _c = ResizeBox_read((0,react.useState)({}), 2), paddingStyles = _c[0], setPaddingStyles = _c[1];
    var _d = ResizeBox_read((0,useMergeValue/* default */.Z)(undefined, { value: propWidth }), 2), width = _d[0], setWidth = _d[1];
    var _e = ResizeBox_read((0,useMergeValue/* default */.Z)(undefined, { value: propHeight }), 2), height = _e[0], setHeight = _e[1];
    var recordRef = (0,react.useRef)({
        startX: 0,
        startY: 0,
        startWidth: 0,
        startHeight: 0,
        direction: DIRECTION_RIGHT,
        moving: false,
        padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
    });
    var wrapperRef = (0,react.useRef)();
    (0,react.useImperativeHandle)(ref, function () { return wrapperRef.current; }, []);
    function getIsHorizontal(direction) {
        return [DIRECTION_TOP, DIRECTION_BOTTOM].indexOf(direction) > -1;
    }
    function getRealSize(clientSize, padding) {
        if (clientSize === 0)
            return 0;
        var res = clientSize - padding;
        return res <= 0 ? 0 : res;
    }
    //
    function setOrResetBodyCursor(cursor) {
        var attrKey = 'data-arco-origin-cursor';
        if (cursor) {
            // 因为只会覆盖内联样式的 cursor，所以只需要记录下原本内联的 cursor 值即可。
            document.body.setAttribute(attrKey, document.body.style.cursor);
            document.body.style.cursor = cursor;
        }
        else {
            // reset to origin cursor
            var originCursor = document.body.getAttribute(attrKey);
            document.body.style.cursor = originCursor || '';
            document.body.removeAttribute(attrKey);
        }
    }
    function onTriggerMouseDown(direction, e) {
        var _a, _b;
        props.onMovingStart && props.onMovingStart();
        recordRef.current.moving = true;
        recordRef.current.startX = e.pageX;
        recordRef.current.startY = e.pageY;
        recordRef.current.direction = direction;
        // 因为 clientWidth 拿到的尺寸包含 padding，而 padding 不应该成为 width 计算的一部分，所以需要去掉。
        var _c = recordRef.current.padding, top = _c.top, left = _c.left, right = _c.right, bottom = _c.bottom;
        recordRef.current.startWidth = getRealSize((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth, left + right);
        recordRef.current.startHeight = getRealSize((_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight, top + bottom);
        (0,dom.on)(window, 'mousemove', moving);
        (0,dom.on)(window, 'touchmove', moving);
        (0,dom.on)(window, 'mouseup', moveEnd);
        (0,dom.on)(window, 'touchend', moveEnd);
        (0,dom.on)(window, 'contextmenu', moveEnd);
        setOrResetBodyCursor(getIsHorizontal(direction) ? 'row-resize' : 'col-resize');
    }
    function moving(e) {
        if (!recordRef.current.moving)
            return false;
        var _a = recordRef.current, startX = _a.startX, startY = _a.startY, startWidth = _a.startWidth, startHeight = _a.startHeight;
        var newWidth = startWidth;
        var newHeight = startHeight;
        // 往右移动的距离
        var offsetX = e.pageX - startX;
        // 往下移动的距离
        var offsetY = e.pageY - startY;
        switch (recordRef.current.direction) {
            case DIRECTION_LEFT:
                newWidth = startWidth - offsetX;
                setWidth(newWidth);
                break;
            case DIRECTION_RIGHT:
                newWidth = startWidth + offsetX;
                setWidth(newWidth);
                break;
            case DIRECTION_TOP:
                newHeight = startHeight - offsetY;
                setHeight(newHeight);
                break;
            case DIRECTION_BOTTOM:
                newHeight = startHeight + offsetY;
                setHeight(newHeight);
                break;
            default:
                break;
        }
        props.onMoving &&
            props.onMoving(e, {
                width: newWidth,
                height: newHeight,
            });
    }
    function moveEnd() {
        recordRef.current.moving = false;
        offEvents();
        setOrResetBodyCursor();
        props.onMovingEnd && props.onMovingEnd();
    }
    function offEvents() {
        (0,dom/* off */.S1)(window, 'mousemove', moving);
        (0,dom/* off */.S1)(window, 'touchmove', moving);
        (0,dom/* off */.S1)(window, 'mouseup', moveEnd);
        (0,dom/* off */.S1)(window, 'touchend', moveEnd);
        (0,dom/* off */.S1)(window, 'contextmenu', moveEnd);
    }
    function onTriggerResize(direction, e) {
        var isHorizontal = getIsHorizontal(direction);
        var contentRect = e[0].contentRect;
        var styleDirection = "" + direction.slice(0, 1).toUpperCase() + direction.slice(1);
        var size = contentRect[isHorizontal ? 'height' : 'width'];
        // 记录 padding，用于计算 width
        recordRef.current.padding[direction] = size;
        setPaddingStyles(function (pre) {
            var _a;
            return (ResizeBox_assign(ResizeBox_assign({}, pre), (_a = {}, _a["padding" + styleDirection] = size, _a)));
        });
    }
    var wrapperStyles = ResizeBox_assign(ResizeBox_assign(ResizeBox_assign(ResizeBox_assign({}, paddingStyles), (style || {})), ((0,is/* isNumber */.hj)(width) ? { width: width } : {})), ((0,is/* isNumber */.hj)(height) ? { height: height } : {}));
    var Tag = component;
    return (react.createElement(Tag, ResizeBox_assign({}, (0,omit/* default */.Z)(rest, ['onMovingStart', 'onMoving', 'onMovingEnd']), { style: wrapperStyles, className: classNames, ref: wrapperRef }),
        children,
        realDirections.map(function (direction) {
            if (allDirections.indexOf(direction) !== -1) {
                return (react.createElement(ResizeTrigger, { key: direction, className: prefixCls + "-direction-" + direction, direction: getIsHorizontal(direction) ? 'horizontal' : 'vertical', icon: resizeIcons[direction], onMouseDown: function (e) {
                        onTriggerMouseDown(direction, e);
                    }, onResize: function (e) {
                        onTriggerResize(direction, e);
                    } }, resizeTriggers[direction]));
            }
        })));
}
var ForwardRefResizeBox = (0,react.forwardRef)(ResizeBox);
var ResizeBoxComponent = ForwardRefResizeBox;
ResizeBoxComponent.Split = split;
ResizeBoxComponent.SplitGroup = split_group;
ResizeBoxComponent.displayName = 'ResizeBox';
/* harmony default export */ var es_ResizeBox = (ResizeBoxComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/responsiveObserve.js
var responsiveObserve = __webpack_require__(6901);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Layout/sider.js
var sider_assign = (undefined && undefined.__assign) || function () {
    sider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return sider_assign.apply(this, arguments);
};
var sider_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









var SiderContext = (0,react.createContext)({
    siderCollapsed: false,
    collapsedWidth: 64,
});
var generateId = (function () {
    var i = 0;
    return function (prefix) {
        if (prefix === void 0) { prefix = ''; }
        i += 1;
        return "" + prefix + i;
    };
})();
function Sider(props, ref) {
    var _a;
    var _b;
    var children = props.children, className = props.className, style = props.style, _c = props.theme, theme = _c === void 0 ? 'light' : _c, trigger = props.trigger, reverseArrow = props.reverseArrow, _d = props.collapsedWidth, collapsedWidth = _d === void 0 ? 48 : _d, _e = props.width, width = _e === void 0 ? 200 : _e, collapsible = props.collapsible, resizeDirections = props.resizeDirections, onSiderMount = props.onSiderMount, onSiderUnmount = props.onSiderUnmount, breakpoint = props.breakpoint, onBreakpoint = props.onBreakpoint, onCollapse = props.onCollapse, _f = props.resizeBoxProps, resizeBoxProps = _f === void 0 ? {} : _f;
    var uniqueId = generateId('arco-sider-');
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('layout-sider');
    var _g = sider_read((0,useMergeValue/* default */.Z)(false, {
        value: 'collapsed' in props ? props.collapsed : undefined,
        defaultValue: props.defaultCollapsed,
    }), 2), collapsed = _g[0], setCollapsed = _g[1];
    // Parsing props width from number to string, to be used as css property value.
    // Using px as the default unit
    var propsWidth = (0,is/* isNumber */.hj)(width) ? width + "px" : String(width);
    var _collapsedWidth = (0,is/* isNumber */.hj)(collapsedWidth) ? "" + collapsedWidth : String(collapsedWidth);
    var _h = sider_read((0,react.useState)(collapsed ? _collapsedWidth : propsWidth), 2), siderWidth = _h[0], setSiderWidth = _h[1];
    var refResponsiveHandlerToken = (0,react.useRef)(null);
    // 提供给 ResponsiveHandler，使得其可以获得最新的 state 值
    var refStateForResponsiveHandler = (0,react.useRef)(null);
    refStateForResponsiveHandler.current = {
        breakpoint: breakpoint,
        collapsed: collapsed,
        onCollapse: onCollapse,
        onBreakpoint: onBreakpoint,
    };
    (0,react.useEffect)(function () {
        onSiderMount && onSiderMount(uniqueId);
        if (collapsible && breakpoint in responsiveObserve/* responsiveMap */.f) {
            refResponsiveHandlerToken.current = responsiveObserve/* default.subscribe */.ZP.subscribe(function (screens, breakpointChecked) {
                var _a = refStateForResponsiveHandler.current, breakpoint = _a.breakpoint, collapsed = _a.collapsed, onCollapse = _a.onCollapse, onBreakpoint = _a.onBreakpoint;
                if (!breakpointChecked || breakpointChecked === breakpoint) {
                    var nextCollapsed = !screens[breakpoint];
                    if (nextCollapsed !== collapsed) {
                        setCollapsed(nextCollapsed);
                        onCollapse && onCollapse(nextCollapsed, 'responsive');
                    }
                    onBreakpoint && onBreakpoint(nextCollapsed);
                }
            });
        }
        return function () {
            onSiderUnmount && onSiderUnmount(uniqueId);
            if (refResponsiveHandlerToken.current) {
                responsiveObserve/* default.unsubscribe */.ZP.unsubscribe(refResponsiveHandlerToken.current);
            }
        };
    }, []);
    (0,react.useEffect)(function () {
        // Parsing collapsed width from number to string, to be used as css property value.
        // Using px as the default unit
        var _collapsedWidth = (0,is/* isNumber */.hj)(collapsedWidth)
            ? collapsedWidth + "px"
            : String(collapsedWidth);
        setSiderWidth(collapsed ? _collapsedWidth : propsWidth);
    }, [collapsed, propsWidth, collapsedWidth]);
    var resizable = (resizeDirections && (0,is/* isArray */.kJ)(resizeDirections)) || ((_b = resizeBoxProps.directions) === null || _b === void 0 ? void 0 : _b.length);
    var TagName = resizable ? es_ResizeBox : 'aside';
    var renderTrigger = function () {
        var _a;
        var triggerIcon = trigger ||
            (collapsed ? (reverseArrow ? (react.createElement(IconLeft/* default */.Z, null)) : (react.createElement(IconRight/* default */.Z, null))) : reverseArrow ? (react.createElement(IconRight/* default */.Z, null)) : (react.createElement(IconLeft/* default */.Z, null)));
        return collapsible && trigger !== null ? (react.createElement("div", { style: { width: siderWidth }, className: (0,_util_classNames/* default */.Z)(prefixCls + "-trigger", (_a = {},
                _a[prefixCls + "-trigger-light"] = theme === 'light',
                _a)), onClick: function () {
                setCollapsed(!collapsed);
                onCollapse && onCollapse(!collapsed, 'clickTrigger');
            } }, triggerIcon)) : null;
    };
    var resizeProps = (0,react.useMemo)(function () {
        if (resizable) {
            return sider_assign(sider_assign({ component: 'aside', onMoving: function (_, _a) {
                    var currentWidth = _a.width;
                    setSiderWidth(currentWidth);
                } }, resizeBoxProps), { width: siderWidth, directions: resizeDirections });
        }
        return {};
    }, [resizable, resizeDirections, siderWidth, resizeBoxProps]);
    return (react.createElement(SiderContext.Provider, { value: {
            siderCollapsed: collapsed,
            collapsedWidth: collapsedWidth,
        } },
        react.createElement(TagName, sider_assign({ ref: ref, style: sider_assign({ width: siderWidth }, style), className: (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
                _a[prefixCls + "-light"] = theme === 'light',
                _a[prefixCls + "-has-trigger"] = trigger !== null && collapsible,
                _a[prefixCls + "-collapsed"] = collapsed,
                _a), className) }, resizeProps),
            react.createElement("div", { className: prefixCls + "-children" }, children),
            renderTrigger())));
}
var ForwardRefSider = (0,react.forwardRef)(Sider);
var SiderComponent = ForwardRefSider;
SiderComponent.displayName = 'LayoutSider';
SiderComponent.__ARCO_SIGN__ = 'sider';
/* harmony default export */ var sider = (SiderComponent);


/***/ }),

/***/ 28096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Menu; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js + 1 modules
var es = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsFirstRender.js
var useIsFirstRender = __webpack_require__(91626);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/context.js

var MenuContext = (0,react.createContext)({});
/* harmony default export */ var context = (MenuContext);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/indent.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


function MenuIndent(props) {
    var prefixCls = props.prefixCls, levelIndent = props.levelIndent;
    var collapse = (0,react.useContext)(context).collapse;
    var level = props.level - 1;
    return !collapse && level > 0 ? (react.createElement("span", null, __spreadArray([], __read(new Array(level)), false).map(function (_, index) {
        return (react.createElement("span", { key: index, className: prefixCls + "-indent", style: { width: levelIndent } }));
    }))) : null;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/util.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var util_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var util_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var PROPS_NEED_TO_BE_PASSED_IN_SUBMENU = ['popup', 'triggerProps', 'selectable'];
// Expand MenuGroup to get an array only contains MenuItem and SubMenu
var flatMenuGroup = function (children) {
    var validMenuItems = [];
    react.Children.forEach(children, function (item) {
        var _a;
        var menuType = (_a = item === null || item === void 0 ? void 0 : item.type) === null || _a === void 0 ? void 0 : _a.menuType;
        if (menuType === 'MenuItem' || menuType === 'SubMenu') {
            validMenuItems.push(item);
        }
        else if (menuType === 'MenuGroup') {
            validMenuItems = validMenuItems.concat(flatMenuGroup(item.props.children));
        }
    });
    return validMenuItems;
};
var generateInfoMap = function (children, keyPath, result) {
    if (keyPath === void 0) { keyPath = []; }
    if (result === void 0) { result = {}; }
    var validChildrenList = flatMenuGroup(children);
    validChildrenList.forEach(function (item, index) {
        var _a;
        var _b, _c;
        var key = item.key;
        var menuType = item.type.menuType;
        var _keyPath = util_spreadArray([key], util_read(keyPath), false);
        var info = {
            keyPath: [],
            prev: ((_b = validChildrenList[index - 1]) === null || _b === void 0 ? void 0 : _b.key) || null,
            next: ((_c = validChildrenList[index + 1]) === null || _c === void 0 ? void 0 : _c.key) || null,
        };
        if (index === 0 || index === validChildrenList.length - 1) {
            var parentKey = _keyPath[1];
            var propertyName = index === 0 ? 'firstChild' : 'lastChild';
            if (parentKey) {
                result[parentKey] = __assign(__assign({}, result[parentKey]), (_a = {}, _a[propertyName] = key, _a));
            }
        }
        switch (menuType) {
            case 'SubMenu':
                info.keyPath = _keyPath;
                generateInfoMap(item.props.children, _keyPath, result);
                break;
            case 'MenuItem':
                info.keyPath = _keyPath;
                info.disabled = item.props.disabled;
                break;
            default:
                break;
        }
        result[key] = __assign(__assign({}, result[key]), info);
    });
    return result;
};
var processChildren = function (children, props) {
    return react.Children.map(children, function (item, index) {
        if (!item || !item.props) {
            return item;
        }
        var isHTMLElement = typeof item.type === 'string';
        var isMenuSubComponent = item.type && item.type.menuType;
        // 处理 <div> 包裹 MenuItem 之类的情况
        if (!isMenuSubComponent && item.props.children) {
            var _props = isHTMLElement ? {} : props;
            var itemChildrenList = processChildren(item.props.children, props);
            return react.cloneElement(item, __assign(__assign({}, _props), { _key: item.key, children: itemChildrenList.length === 1 ? itemChildrenList[0] : itemChildrenList }));
        }
        return isHTMLElement
            ? item
            : react.cloneElement(item, __assign(__assign(__assign({}, props), item.props), { _key: item.key || "$menu-" + index }));
    });
};
function isChildrenSelected(children, keys) {
    var find = false;
    function loop(_children) {
        if (!_children || find) {
            return;
        }
        react.Children.forEach(_children, function (c) {
            if (c && c.props && c.type && !find) {
                var menuType = c.type.menuType;
                var selectable = c.props.selectable;
                if (menuType === 'MenuItem') {
                    find = keys.indexOf(c.key) !== -1;
                }
                else if (menuType === 'SubMenu' && selectable) {
                    find = keys.indexOf(c.key) !== -1;
                }
                if (!find && c.props.children) {
                    loop(c.props.children);
                }
            }
        });
    }
    loop(children);
    return find;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/item.js
var item_assign = (undefined && undefined.__assign) || function () {
    item_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return item_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};










function Item(props, ref) {
    var _a;
    var _key = props._key, children = props.children, level = props.level, disabled = props.disabled, className = props.className, style = props.style, _b = props.wrapper, WrapperTagName = _b === void 0 ? 'div' : _b, onClick = props.onClick, renderItemInTooltip = props.renderItemInTooltip, rest = __rest(props, ["_key", "children", "level", "disabled", "className", "style", "wrapper", "onClick", "renderItemInTooltip"]);
    var _c = (0,react.useContext)(context), prefixCls = _c.prefixCls, mode = _c.mode, collapse = _c.collapse, inDropdown = _c.inDropdown, levelIndent = _c.levelIndent, selectedKeys = _c.selectedKeys, autoScrollIntoView = _c.autoScrollIntoView, scrollConfig = _c.scrollConfig, tooltipProps = _c.tooltipProps, onClickMenuItem = _c.onClickMenuItem;
    var refElement = (0,react.useRef)(null);
    var isFirstRender = (0,useIsFirstRender/* default */.Z)();
    var needTextIndent = mode === 'vertical' && level > 1;
    var needTooltip = collapse && !inDropdown && level === 1;
    var isSelected = selectedKeys && ~selectedKeys.indexOf(_key);
    (0,react.useEffect)(function () {
        var shouldScroll = isSelected && autoScrollIntoView;
        if (refElement.current && shouldScroll) {
            // 首次渲染需要等待展开动画结束之后滚动
            setTimeout(function () {
                refElement.current &&
                    (0,es/* default */.Z)(refElement.current, item_assign({ behavior: 'smooth', block: 'start', scrollMode: 'if-needed', boundary: document.body }, scrollConfig));
            }, isFirstRender ? 500 : 0);
        }
    }, [isSelected, autoScrollIntoView]);
    var menuItemClickHandler = function (event) {
        if (!disabled) {
            onClickMenuItem(_key, event);
            onClick && onClick(event);
        }
    };
    var itemElement = (react.createElement(WrapperTagName, item_assign({ tabIndex: disabled ? -1 : 0, role: "menuitem", ref: function (_ref) {
            ref = _ref;
            refElement.current = ref;
        }, style: style, className: (0,classNames/* default */.Z)(prefixCls + "-item", (_a = {},
            _a[prefixCls + "-disabled"] = disabled,
            _a[prefixCls + "-selected"] = isSelected,
            // 存在缩进dom
            _a[prefixCls + "-item-indented"] = needTextIndent && !collapse,
            _a), className), onClick: menuItemClickHandler, onKeyDown: function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode === keycode/* Enter.code */.Ce.code) {
                menuItemClickHandler(event);
            }
        } }, (0,omit/* default */.Z)(rest, ['key', '_key'].concat(PROPS_NEED_TO_BE_PASSED_IN_SUBMENU))),
        needTextIndent && !collapse ? (react.createElement(react.Fragment, null,
            react.createElement(MenuIndent, { prefixCls: prefixCls, levelIndent: levelIndent, level: level }),
            react.createElement("span", { className: prefixCls + "-item-inner", style: {
                    display: 'block',
                } }, children))) : (children),
        isSelected && mode === 'horizontal' ? (react.createElement("div", { className: prefixCls + "-selected-label" })) : null));
    return needTooltip ? (react.createElement(Tooltip/* default */.Z, item_assign({ trigger: "hover", position: "right", content: typeof renderItemInTooltip === 'function' ? renderItemInTooltip() : react.createElement("span", null, children), triggerProps: item_assign({ className: prefixCls + "-item-tooltip" }, ((tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.triggerProps) || {})) }, (0,omit/* default */.Z)(tooltipProps, ['triggerProps'])), itemElement)) : (itemElement);
}
var ForwardRefItem = (0,react.forwardRef)(Item);
var ItemComponent = ForwardRefItem;
ItemComponent.displayName = 'MenuItem';
ItemComponent.menuType = 'MenuItem';
/* harmony default export */ var item = (ItemComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/item-group.js





function ItemGroup(props, ref) {
    var children = props.children, title = props.title, level = props.level, className = props.className, style = props.style;
    var _a = (0,react.useContext)(context), prefixCls = _a.prefixCls, levelIndent = _a.levelIndent;
    var childrenLevel = level === 1 ? level + 1 : level;
    var childrenList = processChildren(children, { level: childrenLevel });
    return (react.createElement("div", { ref: ref, className: (0,classNames/* default */.Z)(prefixCls + "-group", className), style: style },
        react.createElement("div", { className: prefixCls + "-group-title" },
            react.createElement(MenuIndent, { level: level, prefixCls: prefixCls, levelIndent: levelIndent }),
            react.createElement("span", null, title)),
        childrenList));
}
var ForwardRefItemGroup = (0,react.forwardRef)(ItemGroup);
var ItemGroupComponent = ForwardRefItemGroup;
ItemGroupComponent.displayName = 'MenuItemGroup';
ItemGroupComponent.menuType = 'MenuGroup';
/* harmony default export */ var item_group = (ItemGroupComponent);

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useStateWithPromise.js
var useStateWithPromise = __webpack_require__(23259);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDown/index.js
var IconDown = __webpack_require__(31944);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useId.js
var useId = __webpack_require__(74732);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/sub-menu/inline.js
var inline_assign = (undefined && undefined.__assign) || function () {
    inline_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return inline_assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var inline_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var inline_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












// Use visibility: hidden to avoid Menu.Item get focused by Tab key
var CONTENT_HIDDEN_STYLE = { height: 0, visibility: 'hidden' };
var SubMenuInline = function (props) {
    var _a;
    var _key = props._key, children = props.children, style = props.style, className = props.className, title = props.title, level = props.level, forwardedRef = props.forwardedRef, selectable = props.selectable, rest = inline_rest(props, ["_key", "children", "style", "className", "title", "level", "forwardedRef", "selectable"]);
    var _b = (0,react.useContext)(context), menuId = _b.id, prefixCls = _b.prefixCls, levelIndent = _b.levelIndent, _c = _b.openKeys, openKeys = _c === void 0 ? [] : _c, _d = _b.selectedKeys, selectedKeys = _d === void 0 ? [] : _d, icons = _b.icons, onClickSubMenu = _b.onClickSubMenu, onClickMenuItem = _b.onClickMenuItem;
    var baseClassName = prefixCls + "-inline";
    var isOpen = (openKeys === null || openKeys === void 0 ? void 0 : openKeys.indexOf(_key)) > -1;
    var isSelected = (selectable && selectedKeys.indexOf(props._key) > -1) ||
        isChildrenSelected(children, selectedKeys);
    var _e = inline_read((0,useStateWithPromise/* default */.Z)(isOpen ? { height: 'auto' } : CONTENT_HIDDEN_STYLE), 2), contentStyle = _e[0], setContentStyle = _e[1];
    var subMenuClickHandler = function (event) {
        onClickSubMenu(_key, level, 'inline');
        selectable && onClickMenuItem(_key, event);
    };
    // Unique ID of this instance
    var instanceId = (0,useId/* default */.Z)(menuId + "-submenu-inline-");
    // Should omit these properties in Menu.Item
    var childrenList = processChildren(children, inline_assign(inline_assign({}, (0,pick/* default */.Z)(rest, PROPS_NEED_TO_BE_PASSED_IN_SUBMENU)), { level: level + 1, selectable: selectable }));
    var header = (react.createElement("div", { tabIndex: 0, "aria-expanded": isOpen, "aria-controls": instanceId, className: (0,classNames/* default */.Z)(baseClassName + "-header", (_a = {},
            _a[prefixCls + "-selected"] = isSelected,
            _a)), onClick: subMenuClickHandler, onKeyDown: function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode === keycode/* Enter.code */.Ce.code) {
                subMenuClickHandler(event);
            }
        } },
        react.createElement(MenuIndent, { level: level, prefixCls: prefixCls, levelIndent: levelIndent }),
        react.createElement("span", null, title),
        react.createElement("span", { className: prefixCls + "-icon-suffix " + (isOpen ? 'is-open' : '') }, icons && icons.horizontalArrowDown ? icons.horizontalArrowDown : react.createElement(IconDown/* default */.Z, null))));
    var content = (react.createElement("div", { id: instanceId, className: (0,classNames/* default */.Z)(baseClassName + "-content"), style: contentStyle }, childrenList));
    return (react.createElement("div", inline_assign({ ref: forwardedRef, className: (0,classNames/* default */.Z)(baseClassName, className), style: style }, (0,omit/* default */.Z)(rest, ['key', 'popup', 'triggerProps'])),
        header,
        react.createElement(CSSTransition/* default */.Z, { in: isOpen, timeout: 200, classNames: baseClassName, unmountOnExit: false, onEnter: function (element) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setContentStyle(CONTENT_HIDDEN_STYLE)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, setContentStyle({ height: element.scrollHeight })];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onEntered: function () {
                setContentStyle({ height: 'auto' });
            }, onExit: function (element) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setContentStyle({ height: element.scrollHeight })];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, setContentStyle(CONTENT_HIDDEN_STYLE)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); } }, content)));
};
/* harmony default export */ var inline = (SubMenuInline);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Dropdown/index.js + 1 modules
var Dropdown = __webpack_require__(94990);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/sub-menu/pop.js
var pop_assign = (undefined && undefined.__assign) || function () {
    pop_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return pop_assign.apply(this, arguments);
};
var pop_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var pop_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};














var SubMenuPop = function (props) {
    var _a;
    var _key = props._key, children = props.children, style = props.style, className = props.className, title = props.title, level = props.level, selectable = props.selectable, forwardedRef = props.forwardedRef, propTriggerProps = props.triggerProps, rest = pop_rest(props, ["_key", "children", "style", "className", "title", "level", "selectable", "forwardedRef", "triggerProps"]);
    var _b = (0,react.useContext)(context), menuId = _b.id, prefixCls = _b.prefixCls, mode = _b.mode, inDropdown = _b.inDropdown, levelIndent = _b.levelIndent, _c = _b.selectedKeys, selectedKeys = _c === void 0 ? [] : _c, icons = _b.icons, contextTriggerProps = _b.triggerProps, onClickSubMenu = _b.onClickSubMenu, onClickMenuItem = _b.onClickMenuItem;
    var rtl = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).rtl;
    var triggerProps = pop_assign(pop_assign({}, contextTriggerProps), propTriggerProps);
    var _d = pop_read((0,react.useState)(false), 2), popupVisible = _d[0], setPopupVisible = _d[1];
    var baseClassName = prefixCls + "-pop";
    var isSelected = selectable && selectedKeys.indexOf(props._key) > -1;
    var needPopOnBottom = mode === 'horizontal' && !inDropdown;
    // Unique ID of this instance
    var instanceId = (0,useId/* default */.Z)(menuId + "-submenu-pop-");
    var renderSuffix = function () {
        var MergedIconRight = icons && icons.popArrowRight ? icons.popArrowRight : rtl ? react.createElement(IconLeft/* default */.Z, null) : react.createElement(IconRight/* default */.Z, null);
        var MergedIconDown = icons && icons.horizontalArrowDown ? icons.horizontalArrowDown : react.createElement(IconDown/* default */.Z, null);
        return (react.createElement("span", { className: prefixCls + "-icon-suffix" }, needPopOnBottom ? MergedIconDown : MergedIconRight));
    };
    var hasSelectedStatus = isChildrenSelected(children, selectedKeys) || isSelected;
    var popPosition = rtl ? ['br', 'lt'] : ['bl', 'rt'];
    var subMenuClickHandler = function (event) {
        onClickSubMenu(_key, level, 'pop');
        selectable && onClickMenuItem(_key, event);
    };
    return (react.createElement(Dropdown/* default */.Z, { trigger: "hover", popupVisible: popupVisible, onVisibleChange: setPopupVisible, droplist: react.createElement(es_Menu, { id: instanceId, selectedKeys: selectedKeys, onClickMenuItem: function (key, event) {
                onClickMenuItem(key, event);
                setPopupVisible(false);
            } }, children), triggerProps: pop_assign({ position: needPopOnBottom ? popPosition[0] : popPosition[1], showArrow: true, autoAlignPopupMinWidth: true, classNames: 'fadeIn', duration: 100, mouseEnterDelay: 50, mouseLeaveDelay: 50, className: (0,classNames/* default */.Z)(baseClassName + "-trigger", triggerProps && triggerProps.className) }, (0,omit/* default */.Z)(triggerProps, ['className'])) },
        react.createElement("div", pop_assign({ tabIndex: 0, "aria-haspopup": true, "aria-expanded": popupVisible, "aria-controls": instanceId, ref: forwardedRef, style: style, className: (0,classNames/* default */.Z)(baseClassName, baseClassName + "-header", (_a = {},
                _a[prefixCls + "-selected"] = hasSelectedStatus,
                _a), className), onClick: subMenuClickHandler, onKeyDown: function (event) {
                var keyCode = event.keyCode || event.which;
                if (keyCode === keycode/* Enter.code */.Ce.code) {
                    subMenuClickHandler(event);
                }
                else if (keyCode === keycode/* ArrowLeft.code */.Xd.code) {
                    setPopupVisible(false);
                }
                else if (keyCode === keycode/* ArrowRight.code */.ol.code) {
                    setPopupVisible(true);
                }
            } }, (0,omit/* default */.Z)(rest, ['key', 'popup'])),
            react.createElement(MenuIndent, { prefixCls: prefixCls, levelIndent: levelIndent, level: level }),
            title,
            renderSuffix(),
            hasSelectedStatus && mode === 'horizontal' ? (react.createElement("div", { className: prefixCls + "-selected-label" })) : null)));
};
/* harmony default export */ var pop = (SubMenuPop);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/sub-menu/index.js
var sub_menu_assign = (undefined && undefined.__assign) || function () {
    sub_menu_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return sub_menu_assign.apply(this, arguments);
};




function SubMenu(props, ref) {
    var children = props.children, popup = props.popup, level = props.level;
    var _a = (0,react.useContext)(context), mode = _a.mode, collapse = _a.collapse, inDropdown = _a.inDropdown, collectInlineMenuKeys = _a.collectInlineMenuKeys;
    var forcePopup = !!(typeof popup === 'function' ? popup(level) : popup);
    var mergedPopup = forcePopup || collapse || inDropdown || mode !== 'vertical';
    var MergedMenu = mergedPopup ? pop : inline;
    (0,react.useEffect)(function () {
        collectInlineMenuKeys(props._key);
        return function () {
            collectInlineMenuKeys(props._key, true);
        };
    }, []);
    return (react.createElement(MergedMenu, sub_menu_assign({ forwardedRef: ref }, props), children));
}
var ForwardRefSubMenu = (0,react.forwardRef)(SubMenu);
var SubMenuComponent = ForwardRefSubMenu;
SubMenuComponent.displayName = 'SubMenu';
SubMenuComponent.menuType = 'SubMenu';
/* harmony default export */ var sub_menu = (SubMenuComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/style.js
var style = __webpack_require__(70556);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/overflow-wrap.js
var overflow_wrap_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var overflow_wrap_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};





var OVERFLOW_THRESHOLD = 5;
function getNodeWidth(node) {
    // getBoundingClientRect will get a result like 20.45
    // Use Math.ceil to avoid menu item wrap in specific menu-width
    return node && Math.ceil(+node.getBoundingClientRect().width);
}
function translatePxToNumber(str) {
    var result = Number(str.replace('px', ''));
    return isNaN(result) ? 0 : result;
}
var OverflowWrap = function (props) {
    var children = props.children, _a = props.ellipsisText, ellipsisText = _a === void 0 ? '···' : _a;
    var prefixCls = (0,react.useContext)(context).prefixCls;
    var refUl = (0,react.useRef)(null);
    var _b = overflow_wrap_read((0,react.useState)(null), 2), lastVisibleIndex = _b[0], setLastVisibleIndex = _b[1];
    var overflowSubMenuClass = prefixCls + "-overflow-sub-menu";
    var overflowMenuItemClass = prefixCls + "-overflow-hidden-menu-item";
    var overflowSubMenuMirrorClass = prefixCls + "-overflow-sub-menu-mirror";
    function computeLastVisibleIndex() {
        if (!refUl.current) {
            return;
        }
        var ulElement = refUl.current;
        var maxWidth = getNodeWidth(ulElement) - OVERFLOW_THRESHOLD;
        var childNodeList = [].slice.call(ulElement.children);
        var menuItemIndex = 0;
        var currentItemRight = 0;
        var overflowSubMenuWidth = 0;
        // 注意 childrenNodeList.length !== React.Children.count(children) 所以需要用 menuItemIndex 来标记真实的 MenuItem 下标
        for (var i = 0; i < childNodeList.length; i++) {
            var node = childNodeList[i];
            var classNames = node.className.split(' ');
            var isOverflowSubMenu = classNames.indexOf(overflowSubMenuClass) > -1;
            var isOverflowSubMenuMirror = classNames.indexOf(overflowSubMenuMirrorClass) > -1;
            // 忽略 overflowSubMenu 的宽度，其宽度测量交由 overflowSubMenuMirror
            if (isOverflowSubMenu) {
                continue;
            }
            var nodeWidth = getNodeWidth(node) +
                translatePxToNumber((0,style/* getStyle */.C2)(node, 'marginLeft')) +
                translatePxToNumber((0,style/* getStyle */.C2)(node, 'marginRight'));
            if (isOverflowSubMenuMirror) {
                overflowSubMenuWidth = nodeWidth;
                continue;
            }
            currentItemRight += nodeWidth;
            // 将要溢出的菜单项
            if (currentItemRight > maxWidth) {
                setLastVisibleIndex(
                // 判断如果将最后一个菜单项换为 ... 是否会超出宽度
                menuItemIndex - (currentItemRight - nodeWidth + overflowSubMenuWidth <= maxWidth ? 1 : 2));
                return;
            }
            menuItemIndex++;
        }
        // 全部可见
        setLastVisibleIndex(null);
    }
    var renderOverflowSubMenu = function (children, isMirror) {
        if (isMirror === void 0) { isMirror = false; }
        return (react.createElement(sub_menu, { title: react.createElement("span", null, ellipsisText), key: "arco-menu-overflow-sub-menu" + (isMirror ? '-mirror' : ''), className: isMirror ? overflowSubMenuMirrorClass : overflowSubMenuClass, children: children }));
    };
    var renderChildren = function () {
        var overflowSubMenu = null;
        var overflowSubMenuMirror = renderOverflowSubMenu(null, true);
        var originMenuItems = react.Children.map(children, function (child, index) {
            var item = child;
            if (lastVisibleIndex !== null) {
                if (index > lastVisibleIndex) {
                    item = react.cloneElement(child, {
                        className: overflowMenuItemClass,
                    });
                }
                if (index === lastVisibleIndex + 1) {
                    var overflowedItems = react.Children.toArray(children)
                        .slice(lastVisibleIndex + 1)
                        .map(function (child) {
                        return react.cloneElement(child, { key: child.props._key });
                    });
                    overflowSubMenu = renderOverflowSubMenu(overflowedItems);
                }
            }
            return item;
        });
        return overflow_wrap_spreadArray(overflow_wrap_spreadArray([overflowSubMenuMirror], overflow_wrap_read(originMenuItems), false), [overflowSubMenu], false);
    };
    return (react.createElement(resizeObserver/* default */.Z, { onResize: computeLastVisibleIndex },
        react.createElement("div", { className: prefixCls + "-overflow-wrap", ref: refUl }, renderChildren())));
};
/* harmony default export */ var overflow_wrap = (OverflowWrap);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Layout/sider.js + 5 modules
var sider = __webpack_require__(1389);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/context.js
var react_icon_context = __webpack_require__(4245);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMenuFold/index.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconMenuFoldComponent(iconProps, ref) {
  var _useContext = (0,react.useContext)(react_icon_context/* IconContext */.P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-menu-fold")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M42 11H6M42 24H22M42 37H6M13.66 26.912l-4.82-3.118 4.82-3.118v6.236Z"
  }));
}

var IconMenuFold = /*#__PURE__*/react.forwardRef(IconMenuFoldComponent);
IconMenuFold.defaultProps = {
  isIcon: true
};
IconMenuFold.displayName = 'IconMenuFold';
/* harmony default export */ var react_icon_IconMenuFold = (IconMenuFold);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconMenuUnfold/index.js



function IconMenuUnfold_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function IconMenuUnfold_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { IconMenuUnfold_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { IconMenuUnfold_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconMenuUnfoldComponent(iconProps, ref) {
  var _useContext = (0,react.useContext)(react_icon_context/* IconContext */.P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = IconMenuUnfold_objectSpread(IconMenuUnfold_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-menu-unfold")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M6 11h36M22 24h20M6 37h36M8 20.882 12.819 24 8 27.118v-6.236Z"
  }));
}

var IconMenuUnfold = /*#__PURE__*/react.forwardRef(IconMenuUnfoldComponent);
IconMenuUnfold.defaultProps = {
  isIcon: true
};
IconMenuUnfold.displayName = 'IconMenuUnfold';
/* harmony default export */ var react_icon_IconMenuUnfold = (IconMenuUnfold);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useForceUpdate.js
var useForceUpdate = __webpack_require__(65166);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Menu/index.js
var Menu_assign = (undefined && undefined.__assign) || function () {
    Menu_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Menu_assign.apply(this, arguments);
};
var Menu_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var Menu_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var Menu_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



















var DEFAULT_THEME = 'light';
var defaultProps = {
    mode: 'vertical',
    selectable: true,
    ellipsis: true,
};
function Menu(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Menu);
    var style = props.style, children = props.children, className = props.className, menuPrefixCls = props.prefixCls, mode = props.mode, propTheme = props.theme, icons = props.icons, levelIndent = props.levelIndent, propCollapse = props.collapse, inDropdown = props.inDropdown, selectable = props.selectable, triggerProps = props.triggerProps, tooltipProps = props.tooltipProps, ellipsis = props.ellipsis, accordion = props.accordion, autoOpen = props.autoOpen, autoScrollIntoView = props.autoScrollIntoView, scrollConfig = props.scrollConfig, hasCollapseButton = props.hasCollapseButton, defaultOpenKeys = props.defaultOpenKeys, defaultSelectedKeys = props.defaultSelectedKeys, propOpenKeys = props.openKeys, propSelectedKeys = props.selectedKeys, onClickSubMenu = props.onClickSubMenu, onClickMenuItem = props.onClickMenuItem, onCollapseChange = props.onCollapseChange, rest = Menu_rest(props, ["style", "children", "className", "prefixCls", "mode", "theme", "icons", "levelIndent", "collapse", "inDropdown", "selectable", "triggerProps", "tooltipProps", "ellipsis", "accordion", "autoOpen", "autoScrollIntoView", "scrollConfig", "hasCollapseButton", "defaultOpenKeys", "defaultSelectedKeys", "openKeys", "selectedKeys", "onClickSubMenu", "onClickMenuItem", "onCollapseChange"]);
    var _c = Menu_read((0,useMergeValue/* default */.Z)([], {
        defaultValue: defaultOpenKeys,
        value: propOpenKeys,
    }), 2), openKeys = _c[0], setOpenKeys = _c[1];
    var _d = Menu_read((0,useMergeValue/* default */.Z)([], {
        defaultValue: defaultSelectedKeys,
        value: propSelectedKeys,
    }), 2), selectedKeys = _d[0], setSelectedKeys = _d[1];
    var _e = Menu_read((0,useMergeValue/* default */.Z)(false, {
        value: propCollapse,
    }), 2), collapse = _e[0], setCollapse = _e[1];
    var menuContext = (0,react.useContext)(context);
    var siderCollapsed = (0,react.useContext)(sider/* SiderContext */.D).siderCollapsed;
    var prefixCls = menuPrefixCls || getPrefixCls('menu');
    var mergedCollapse = siderCollapsed || collapse || inDropdown || mode === 'popButton';
    var theme = propTheme || menuContext.theme || DEFAULT_THEME;
    var refSubMenuKeys = (0,react.useRef)([]);
    var refPrevSubMenuKeys = (0,react.useRef)([]);
    var forceUpdate = (0,useForceUpdate/* default */.Z)();
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var menuInfoMap = (0,react.useMemo)(function () {
        return generateInfoMap(children);
    }, [children]);
    // Unique ID of this instance
    var _instanceId = (0,useId/* default */.Z)(prefixCls + "-");
    var instanceId = rest.id || _instanceId;
    // autoOpen 时，初次渲染展开所有的子菜单
    (0,react.useEffect)(function () {
        // 从 openKeys 中过滤已经不存在的 subMenuKey
        var validOpenKeys = openKeys.filter(function (key) { return refSubMenuKeys.current.indexOf(key) !== -1; });
        if (autoOpen) {
            var keysAdded = refSubMenuKeys.current.filter(function (key) { return refPrevSubMenuKeys.current.indexOf(key) === -1; });
            validOpenKeys = openKeys.concat(keysAdded);
        }
        setOpenKeys(accordion ? validOpenKeys.slice(0, 1) : validOpenKeys);
        refPrevSubMenuKeys.current = refSubMenuKeys.current.slice();
    }, [refSubMenuKeys.current.toString()]);
    var mergedHasCollapseButton = mode !== 'horizontal' && mode !== 'popButton' && !inDropdown && hasCollapseButton;
    var renderChildren = function () {
        var childrenList = processChildren(children, { level: 1 });
        var collapseIcon = collapse
            ? (icons && icons.collapseActive) || react.createElement(react_icon_IconMenuUnfold, null)
            : (icons && icons.collapseDefault) || react.createElement(react_icon_IconMenuFold, null);
        var collapseButtonClickHandler = function () {
            var newCollapse = !collapse;
            setCollapse(newCollapse);
            onCollapseChange && onCollapseChange(newCollapse);
        };
        return (react.createElement(react.Fragment, null,
            react.createElement("div", { className: prefixCls + "-inner" }, mode === 'horizontal' && ellipsis !== false ? (react.createElement(overflow_wrap, { ellipsisText: (0,is/* isObject */.Kn)(ellipsis) ? ellipsis.text : '···' }, childrenList)) : (childrenList)),
            mergedHasCollapseButton && (react.createElement("div", Menu_assign({ tabIndex: 0, role: "button", "aria-controls": instanceId, "aria-expanded": !collapse, className: prefixCls + "-collapse-button", onClick: collapseButtonClickHandler }, getKeyboardEvents({ onPressEnter: collapseButtonClickHandler })), collapseIcon))));
    };
    var usedStyle = Menu_assign({}, style);
    if (mergedCollapse && !inDropdown) {
        delete usedStyle.width;
    }
    return (react.createElement("div", Menu_assign({ id: mergedHasCollapseButton ? instanceId : undefined, role: "menu" }, (0,omit/* default */.Z)(rest, ['isMenu']), { ref: ref, style: usedStyle, className: (0,classNames/* default */.Z)(prefixCls, prefixCls + "-" + theme, prefixCls + "-" + (mode === 'horizontal' ? 'horizontal' : 'vertical'), (_a = {},
            _a[prefixCls + "-collapse"] = mergedCollapse,
            // 缩起状态自动变成 pop 模式
            _a[prefixCls + "-pop"] = mode === 'pop' || mergedCollapse,
            _a[prefixCls + "-pop-button"] = mode === 'popButton',
            _a[prefixCls + "-rtl"] = rtl,
            _a), className) }),
        react.createElement(context.Provider, { value: {
                mode: mode,
                theme: theme,
                collapse: mergedCollapse,
                levelIndent: levelIndent,
                inDropdown: inDropdown,
                selectedKeys: selectedKeys,
                openKeys: openKeys,
                icons: icons,
                triggerProps: triggerProps,
                tooltipProps: tooltipProps,
                autoScrollIntoView: autoScrollIntoView,
                scrollConfig: scrollConfig,
                // pass props directly
                id: instanceId,
                prefixCls: prefixCls,
                collectInlineMenuKeys: function (key, unmount) {
                    if (unmount) {
                        refSubMenuKeys.current = refSubMenuKeys.current.filter(function (x) { return x !== key; });
                    }
                    else {
                        refSubMenuKeys.current.push(key);
                    }
                    forceUpdate();
                },
                onClickMenuItem: function (key, event) {
                    var _a;
                    selectable && setSelectedKeys([key]);
                    onClickMenuItem && onClickMenuItem(key, event, (_a = menuInfoMap[key]) === null || _a === void 0 ? void 0 : _a.keyPath);
                },
                onClickSubMenu: function (key, level, type) {
                    var _a;
                    var newOpenKeys = Menu_spreadArray([], Menu_read(openKeys), false);
                    if (type === 'inline') {
                        if ((openKeys === null || openKeys === void 0 ? void 0 : openKeys.indexOf(key)) > -1) {
                            if (accordion && level === 1) {
                                newOpenKeys = [];
                            }
                            else {
                                newOpenKeys = openKeys.filter(function (item) { return item !== key; });
                            }
                        }
                        else if (accordion && level === 1) {
                            newOpenKeys = [key];
                        }
                        else {
                            newOpenKeys = openKeys.concat([key]);
                        }
                    }
                    setOpenKeys(newOpenKeys);
                    onClickSubMenu && onClickSubMenu(key, newOpenKeys, (_a = menuInfoMap[key]) === null || _a === void 0 ? void 0 : _a.keyPath);
                },
            } }, renderChildren())));
}
var ForwardRefMenu = (0,react.forwardRef)(Menu);
var MenuComponent = ForwardRefMenu;
MenuComponent.displayName = 'Menu';
MenuComponent.Item = item;
MenuComponent.SubMenu = sub_menu;
MenuComponent.ItemGroup = item_group;
MenuComponent.__ARCO_MENU__ = true;
/* harmony default export */ var es_Menu = (MenuComponent);


/***/ }),

/***/ 6901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c4": function() { return /* binding */ responsiveArray; },
/* harmony export */   "f": function() { return /* binding */ responsiveMap; }
/* harmony export */ });
// https://github.com/ant-design/ant-design/blob/master/components/_util/responsiveObserve.ts
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var responsiveArray = ['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var responsiveMap = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1600px)',
    xxxl: '(min-width: 2000px)',
};
var subscribers = [];
var subUid = -1;
var screens = {};
var responsiveObserve = {
    matchHandlers: {},
    dispatch: function (pointMap, breakpointChecked) {
        screens = pointMap;
        if (subscribers.length < 1) {
            return false;
        }
        subscribers.forEach(function (item) {
            item.func(screens, breakpointChecked);
        });
        return true;
    },
    subscribe: function (func) {
        if (subscribers.length === 0) {
            this.register();
        }
        var token = (++subUid).toString();
        subscribers.push({
            token: token,
            func: func,
        });
        func(screens, null);
        return token;
    },
    unsubscribe: function (token) {
        subscribers = subscribers.filter(function (item) { return item.token !== token; });
        if (subscribers.length === 0) {
            this.unregister();
        }
    },
    unregister: function () {
        var _this = this;
        Object.keys(responsiveMap).forEach(function (screen) {
            var matchMediaQuery = responsiveMap[screen];
            var handler = _this.matchHandlers[matchMediaQuery];
            if (handler && handler.mql && handler.listener) {
                handler.mql.removeListener(handler.listener);
            }
        });
    },
    register: function () {
        var _this = this;
        Object.keys(responsiveMap).forEach(function (screen) {
            var matchMediaQuery = responsiveMap[screen];
            var listener = function (_a) {
                var _b;
                var matches = _a.matches;
                _this.dispatch(__assign(__assign({}, screens), (_b = {}, _b[screen] = matches, _b)), screen);
            };
            var mql = window.matchMedia(matchMediaQuery);
            mql.addListener(listener);
            _this.matchHandlers[matchMediaQuery] = {
                mql: mql,
                listener: listener,
            };
            listener(mql);
        });
    },
};
/* harmony default export */ __webpack_exports__["ZP"] = (responsiveObserve);


/***/ }),

/***/ 70556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ getStyle; },
/* harmony export */   "GB": function() { return /* binding */ setTransformStyle; }
/* harmony export */ });
/* unused harmony export fixedWidth */
var transformNames = [
    'transform',
    'WebkitTransform',
    'msTransform',
    'MozTransform',
    'OTransform',
];
function fixedWidth(width) {
    return {
        maxWidth: width,
        minWidth: width,
        width: width,
    };
}
function setTransformStyle(value) {
    var style = {};
    transformNames.forEach(function (name) {
        style[name] = value;
    });
    return style;
}
function getStyle(element, prop) {
    if (!element || !prop)
        return null;
    var styleName = prop;
    if (styleName === 'float') {
        styleName = 'cssFloat';
    }
    try {
        if (document.defaultView) {
            var computed = document.defaultView.getComputedStyle(element, '');
            return element.style[styleName] || computed ? computed[styleName] : '';
        }
    }
    catch (e) {
        return element.style[styleName];
    }
}


/***/ }),

/***/ 99042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCaretDownComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-caret-down")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M24.938 34.829a1.2 1.2 0 0 1-1.875 0L9.56 17.949c-.628-.785-.069-1.949.937-1.949h27.007c1.006 0 1.565 1.164.937 1.95L24.937 34.829Z"
  }));
}

var IconCaretDown = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconCaretDownComponent);
IconCaretDown.defaultProps = {
  isIcon: true
};
IconCaretDown.displayName = 'IconCaretDown';
/* harmony default export */ __webpack_exports__["Z"] = (IconCaretDown);

/***/ }),

/***/ 74280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCaretLeftComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-caret-left")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M13.171 24.937a1.2 1.2 0 0 1 0-1.874L30.051 9.56c.785-.629 1.949-.07 1.949.937v27.006c0 1.006-1.164 1.566-1.95.937L13.171 24.937Z"
  }));
}

var IconCaretLeft = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconCaretLeftComponent);
IconCaretLeft.defaultProps = {
  isIcon: true
};
IconCaretLeft.displayName = 'IconCaretLeft';
/* harmony default export */ __webpack_exports__["Z"] = (IconCaretLeft);

/***/ }),

/***/ 67945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCaretRightComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-caret-right")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M34.829 23.063c.6.48.6 1.394 0 1.874L17.949 38.44c-.785.629-1.949.07-1.949-.937V10.497c0-1.007 1.164-1.566 1.95-.937l16.879 13.503Z"
  }));
}

var IconCaretRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconCaretRightComponent);
IconCaretRight.defaultProps = {
  isIcon: true
};
IconCaretRight.displayName = 'IconCaretRight';
/* harmony default export */ __webpack_exports__["Z"] = (IconCaretRight);

/***/ }),

/***/ 69195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCaretUpComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-caret-up")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M23.063 13.171a1.2 1.2 0 0 1 1.875 0l13.503 16.88c.628.785.069 1.949-.937 1.949H10.497c-1.006 0-1.565-1.164-.937-1.95l13.503-16.879Z"
  }));
}

var IconCaretUp = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconCaretUpComponent);
IconCaretUp.defaultProps = {
  isIcon: true
};
IconCaretUp.displayName = 'IconCaretUp';
/* harmony default export */ __webpack_exports__["Z"] = (IconCaretUp);

/***/ }),

/***/ 81181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconDragDotVerticalComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-drag-dot-vertical")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M17 8h2v2h-2V8ZM17 23h2v2h-2v-2ZM17 38h2v2h-2v-2ZM29 8h2v2h-2V8ZM29 23h2v2h-2v-2ZM29 38h2v2h-2v-2Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M17 8h2v2h-2V8ZM17 23h2v2h-2v-2ZM17 38h2v2h-2v-2ZM29 8h2v2h-2V8ZM29 23h2v2h-2v-2ZM29 38h2v2h-2v-2Z"
  }));
}

var IconDragDotVertical = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconDragDotVerticalComponent);
IconDragDotVertical.defaultProps = {
  isIcon: true
};
IconDragDotVertical.displayName = 'IconDragDotVertical';
/* harmony default export */ __webpack_exports__["Z"] = (IconDragDotVertical);

/***/ }),

/***/ 75469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ scroll_into_view_if_needed_es; }
});

;// CONCATENATED MODULE: ./node_modules/scroll-into-view-if-needed/node_modules/compute-scroll-into-view/es/index.js
function isElement(el) {
  return el != null && typeof el === 'object' && el.nodeType === 1;
}

function canOverflow(overflow, skipOverflowHiddenElements) {
  if (skipOverflowHiddenElements && overflow === 'hidden') {
    return false;
  }

  return overflow !== 'visible' && overflow !== 'clip';
}

function isScrollable(el, skipOverflowHiddenElements) {
  if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
    var style = getComputedStyle(el, null);
    return canOverflow(style.overflowY, skipOverflowHiddenElements) || canOverflow(style.overflowX, skipOverflowHiddenElements);
  }

  return false;
}

function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
  if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) {
    return 0;
  }

  if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) {
    return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
  }

  if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) {
    return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
  }

  return 0;
}

/* harmony default export */ var es = (function (target, options) {
  var scrollMode = options.scrollMode,
      block = options.block,
      inline = options.inline,
      boundary = options.boundary,
      skipOverflowHiddenElements = options.skipOverflowHiddenElements;
  var checkBoundary = typeof boundary === 'function' ? boundary : function (node) {
    return node !== boundary;
  };

  if (!isElement(target)) {
    throw new TypeError('Invalid target');
  }

  var scrollingElement = document.scrollingElement || document.documentElement;
  var frames = [];
  var cursor = target;

  while (isElement(cursor) && checkBoundary(cursor)) {
    cursor = cursor.parentNode;

    if (cursor === scrollingElement) {
      frames.push(cursor);
      break;
    }

    if (cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
      continue;
    }

    if (isScrollable(cursor, skipOverflowHiddenElements)) {
      frames.push(cursor);
    }
  }

  var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
  var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
  var viewportX = window.scrollX || pageXOffset;
  var viewportY = window.scrollY || pageYOffset;

  var _target$getBoundingCl = target.getBoundingClientRect(),
      targetHeight = _target$getBoundingCl.height,
      targetWidth = _target$getBoundingCl.width,
      targetTop = _target$getBoundingCl.top,
      targetRight = _target$getBoundingCl.right,
      targetBottom = _target$getBoundingCl.bottom,
      targetLeft = _target$getBoundingCl.left;

  var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
  var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
  var computations = [];

  for (var index = 0; index < frames.length; index++) {
    var frame = frames[index];

    var _frame$getBoundingCli = frame.getBoundingClientRect(),
        _height = _frame$getBoundingCli.height,
        _width = _frame$getBoundingCli.width,
        _top = _frame$getBoundingCli.top,
        right = _frame$getBoundingCli.right,
        bottom = _frame$getBoundingCli.bottom,
        _left = _frame$getBoundingCli.left;

    if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) {
      return computations;
    }

    var frameStyle = getComputedStyle(frame);
    var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
    var borderTop = parseInt(frameStyle.borderTopWidth, 10);
    var borderRight = parseInt(frameStyle.borderRightWidth, 10);
    var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
    var blockScroll = 0;
    var inlineScroll = 0;
    var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
    var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;

    if (scrollingElement === frame) {
      if (block === 'start') {
        blockScroll = targetBlock;
      } else if (block === 'end') {
        blockScroll = targetBlock - viewportHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - viewportHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline;
      } else if (inline === 'center') {
        inlineScroll = targetInline - viewportWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - viewportWidth;
      } else {
        inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
      }

      blockScroll = Math.max(0, blockScroll + viewportY);
      inlineScroll = Math.max(0, inlineScroll + viewportX);
    } else {
      if (block === 'start') {
        blockScroll = targetBlock - _top - borderTop;
      } else if (block === 'end') {
        blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline - _left - borderLeft;
      } else if (inline === 'center') {
        inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - right + borderRight + scrollbarWidth;
      } else {
        inlineScroll = alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
      }

      var scrollLeft = frame.scrollLeft,
          scrollTop = frame.scrollTop;
      blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
      inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
      targetBlock += scrollTop - blockScroll;
      targetInline += scrollLeft - inlineScroll;
    }

    computations.push({
      el: frame,
      top: blockScroll,
      left: inlineScroll
    });
  }

  return computations;
});
;// CONCATENATED MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = 'scrollBehavior' in document.body.style;
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var targetIsDetached = !target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(targetIsDetached ? [] : es(target, options));
  }

  if (targetIsDetached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(es(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var scroll_into_view_if_needed_es = (scrollIntoView);

/***/ })

}]);